import * as types from './actionTypes'

export function toggleVisibility () {
  return {type: types.TOGGLE_VIS}
}



// WEBPACK FOOTER //
// ./src/actions/viewActions.js